import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import internalState from './internalState';
import { RoundedFilterHeaderWrapper, FlexCenterWrapper } from 'wrappers';
import { Input, Text } from './atoms';
import { DateWrapper } from './wrappers';
import { format } from 'date-fns';
import getIsMobile from "components/atoms/utils/getIsMobile";
import DateInput from '../dateInput';

const isMobile = getIsMobile();

const contentElements = [
  {
    wrapper: DateWrapper,
    name: 'StartDate',
    isButton: true,
    bindings: ({ }) => ({}),
    displayState: ({ editingDate, square }) => ({ isStartDate: true, isSelected: editingDate === 'startDate', square }),
    elements: [
      {
        component: Text,
        name: 'From',
        displayValue: ({ }) => 'From:',
        displayState: ({ }) => ({}),
      },
      {
        component: DateInput,
        name: 'Input',
        bindings: ({ startDate }) => ({ date: startDate })
      },
    ]
  },
  {
    wrapper: DateWrapper,
    name: 'EndDate',
    isButton: true,
    bindings: ({ }) => ({}),
    displayState: ({ editingDate, square }) => ({ isStartDate: false, isSelected: editingDate === 'endDate', square }),
    elements: [
      {
        component: Text,
        name: 'To',
        displayValue: ({ }) => 'To:',
        displayState: ({ }) => ({}),
      },
      {
        component: DateInput,
        name: 'Input',
        bindings: ({ endDate }) => ({ date: endDate })
      },
    ]
  },
]

export const definition = {
  name: 'CustomCalendarHeaderInputs',
  controller: Controller,
  initialProps: ({ startDate, endDate, isReadonly, editingDate, square }) => ({ startDate, endDate, isReadonly, editingDate, square }),
  props: internalState,
  elements: [
    {
      wrapper: isMobile ? FlexCenterWrapper : RoundedFilterHeaderWrapper,
      name: 'HeaderWrapper',
      displayState: ({ isReadonly, startDate, endDate }) => ({ disabled: isReadonly, completed: startDate && endDate, padding: '0px' }),
      elements: contentElements
    },
  ]
};

export const squareDefinition = {
  name: 'CustomCalendarHeaderInputs',
  controller: Controller,
  initialProps: ({ startDate, endDate, isReadonly, editingDate, square }) => ({ startDate, endDate, isReadonly, editingDate, square }),
  props: internalState,
  elements: [
    {
      wrapper: FlexCenterWrapper,
      name: 'HeaderWrapper',
      displayState: ({ isReadonly, startDate, endDate }) => ({ disabled: isReadonly, completed: startDate && endDate, padding: '0px' }),
      elements: contentElements
    },
  ]
};

export const SquareCalendarHeaderInputs = ContainerComponent(squareDefinition);

export default ContainerComponent(definition);